export const tooltipsText = {
  teamIncome:
    'Чтобы зарабатвать 10% с продаж своих менеджеров - необходимо, чтобы у тебя за последние 30 дней было минимум 5 новых платных клиентов',
  inviteToTeam: `Ты можешь пригласить в свою команду работников, которые будут искать клиентов. 
  С оплат их клиентов ты получаешь 10%. Но для начала ты должен собрать 5 клиентов, которые совершат любую оплату.`,
  promoCode:
    'Личный промокод ты даешь клиенту. Клиент получает бесплатно тариф “Тестовый”. За тобой закрепляется данный клиент. C каждой его покупки, ты получаешь 15%.',
};
